import React, {memo} from 'react';
import {Form} from 'antd';
import PropTypes from 'prop-types';
import {EditableContext} from '@/modules/templates/components/TemplateDetailsInSituMeasure/InSituMeasureDesktopView';

const EditableProvider = ({children}) => {
  const [form] = Form.useForm();

  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form} >
        {children}
      </EditableContext.Provider>
    </Form>
  );
};

EditableProvider.propTypes = {
  children: PropTypes.any
};

export default memo(EditableProvider);
